import React, { useState, useEffect } from "react"

import { Row, Col, Input, Switch, Select, Space } from "antd"
import BulletPointTicket from "../welcome/components/BulletPointTick"
import logo_right from "images/shippy/integrations/shopify_right.svg"
import "aos/dist/aos.css"
import { useMediaQuery } from "react-responsive"
import BusinessForm from "../business_pages/components/BusinessForm"
import SuccessModal from "../business_pages/components/SuccessModal"

const bulletPoints = [
  "Platus kurjerių pasirinkimas - išsirinkite ir naudokite tik savo verslui tinkamiausius kurjerius ",
  "Automatizuoti procesai - automatinis užsakymų sichronizavimas ir siuntos dokumentų generavimas leis jums skirti daugiau savo laiko verslo auginimui.",
  "Integracija nemokama - jokių papildomų mokesčių"
]

const IntegrationSection = () => {
  const isMobileScreen = useMediaQuery({ query: "(max-width: 992px)" })
  const [isFormModalVisible, setIsFormModalVisible] = useState(false)
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false)

  return (
    <>
      <Row
        gutter={{ lg: 16 }}
        align="middle"
        style={{
          marginTop: isMobileScreen ? "0px" : "-200px",
        }}
      >
        <Col span={24} lg={{ offset: 2, span: 10 }}>
          <div
            style={{
              width: "100%", display: "flex", justifyContent: "center",
              padding: isMobileScreen ? '15px' : ""
            }}
          >
            <div
              data-aos={isMobileScreen ? "" : "flip-left"}
              style={{
                maxWidth: 600,
              }}
            >
              <h1 className="section-title" style={{ marginTop: isMobileScreen ? "" : "75px" }}>
                {"Shopify integracija vos kelių mygtukų paspaudimu"}
              </h1>
              {/*
              {isMobileScreen ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img src={couriers} style={{ width: "100%", maxWidth: 600 }} />
                </div>
              ) : ('')} */}

              {bulletPoints.map((point, index) => (
                <div className="section-bullet-point" key={index}>
                  <Space size="small">
                    <BulletPointTicket />
                    <div>{point}</div>
                  </Space>
                </div>
              ))}
              <div className="section-buttons">
                <button className="btn btn-primary-alsendo btn-circle btn-lg" onClick={() => {
                  setIsFormModalVisible(true)
                }}>
                  {"Išbandyti"}
                </button>
              </div>
            </div>
          </div>
        </Col>

        <Col span={24} lg={{ offset: 1, span: 11 }}>
          <div
            style={{
              height: !isMobileScreen && 600,
              marginRight: !isMobileScreen && 30,
              marginTop: isMobileScreen ? 0 : 80,
              paddingTop: isMobileScreen ? 0 : 80,
              textAlign: isMobileScreen ? "center" : "left",
            }}
          >
            <img src={logo_right} style={{ width: "80%", maxHeight: "90%" }} />
          </div>
        </Col>
      </Row>
      {isFormModalVisible && (
        <BusinessForm
          setIsFormModalVisible={setIsFormModalVisible}
          setIsSuccessModalVisible={setIsSuccessModalVisible}
        />
      )}
      {isSuccessModalVisible && (
        <SuccessModal setIsSuccessModalVisible={setIsSuccessModalVisible} />
      )}
    </>
  )
}

export default IntegrationSection
